import { storeWrapper } from '../storeWrapper'
import { ospreyAPI } from '@repo/api/ospreyAPI'

const initialState = {
  maxConcurrentUsers: null,
  enforcementEnabled: false
}

export const useLicenceControlStore = storeWrapper('useLicenceControlStore', (set) => ({
  ...initialState,
  fetchLicenceControl: async () => {
    const licenceControl = await ospreyAPI({
      service: 'security',
      endpoint: 'LicenceControl/Get'
    })

    set({
      maxConcurrentUsers: licenceControl?.maxConcurrentUsers ?? null,
      enforcementEnabled: licenceControl?.enforcementEnabled ?? false
    })

    return licenceControl
  },
  updateLicenceControl: async ({ maxConcurrentUsers, enforcementEnabled }) => {
    const licenceControl = await ospreyAPI({
      service: 'security',
      endpoint: 'LicenceControl/Update',
      method: 'POST',
      data: { maxConcurrentUsers, enforcementEnabled }
    })

    set({ maxConcurrentUsers, enforcementEnabled })

    return licenceControl
  },
  reset: () => set(initialState)
}))
